// @flow

export { bankTransferOutgoingPaymentMapper } from './outgoing-payment-mapper';

const banktransfer = {
  dueDateFormat: 'dd/MM/yyyy',
};

export default banktransfer;
